export default {
  name: "add",
  class: `h-6 w-6`,
  box: 24,
  svg: "<path  stroke-linecap='round'  stroke-linejoin='round'  stroke='fillcolor'  stroke-width='2'  d='M12 6v6m0 0v6m0-6h6m-6 0H6'  />",
};
